/*
  EmsChallengeFriend
*/

import React, { Component } from 'react';
import autoBind from 'react-autobind';
// import classnames from 'classnames';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import { withApollo } from 'react-apollo';
import gql from 'graphql-tag';
import { compose, bindActionCreators } from 'redux';
import { addMessage } from 'store/features/common/flash/actions';
import { connectModal as reduxModal, hide as hideModal } from 'redux-modal';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'ui/common/modal';

import { messageTypes } from 'store/features/common/flash/builder';
import { resultHasErrors, errorsToSingleMessage } from 'utils/graphql-errors';

import TextField from 'ui/common/form/fields/text-field';
import validator from 'ui/common/form/validator';
import SubmitButton from 'ui/common/form/submit-button';
import fields, { fieldNames } from './model';
import styles from './index.module.scss';
import messages from './messages';
import * as actionTypes from 'store/graphql/EmsChallengeFriend/action-types';
import {
  selectIsFetching,
  selectIsUpdating,
  selectError,
} from 'store/graphql/EmsChallengeFriend/selectors';
import EmsChallengeFriendReducer from 'store/graphql/EmsChallengeFriend/reducer';
import injectReducer from 'utils/injectReducer';
const validate = validator(fields);
const formName = 'ems-challenge-friend';

export const MODAL_NAME = 'ems-challenge-a-friend-modal';

class EmsChallengeFriend extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  async onSubmit(values) {
    const {
      client,
      sendInvitationStart,
      sendInvitationSuccess,
      sendInvitationError,
      hideModal,
      addMessage,
    } = this.props;

    sendInvitationStart();

    try {
      const resultFromGraphQl = await client.mutate({
        mutation: gql`
          mutation ems_employee_challengeFriend($email: String!) {
            ems_employee_challengeFriend(email: $email)
          }
        `,
        variables: {
          email: values.email,
        },
      });

      if (resultHasErrors(resultFromGraphQl)) {
        addMessage(errorsToSingleMessage(resultFromGraphQl));
        sendInvitationError(resultFromGraphQl.error);
      } else {
        sendInvitationSuccess();
        addMessage({
          kind: messageTypes.success,
          content: 'Invitation sent successfully!',
        });
        hideModal(MODAL_NAME);
      }
    } catch (error) {
      sendInvitationError(error.message);
      addMessage(error.message);
    }
  }

  render() {
    const {
      show,
      handleHide,
      handleSubmit,
      intl: { formatMessage },
      invalid,
      updating,
    } = this.props;

    return (
      <Modal size="lg" isOpen={show}>
        <form onSubmit={handleSubmit(this.onSubmit)}>
          <ModalHeader toggle={handleHide} className="justify-center-center" />
          <ModalBody>
            <div className="text-center">
              <h1 className={styles.title}>
                <b>{formatMessage(messages.title)}</b>
              </h1>
              <hr
                style={{
                  width: '200px',
                  backgroundColor: '#00B1A4',
                  height: '4px',
                }}
              />
            </div>
            <div className="row justify-content-center">
              <div className="col-8">
                <Field
                  label={formatMessage(messages[fieldNames.email])}
                  name={fieldNames.email}
                  component={TextField}
                />
              </div>
            </div>
          </ModalBody>
          <ModalFooter className="m-auto">
            <SubmitButton
              isReady
              formName={formName}
              className="m-auto py-2 px-4"
              style={{ fontSize: '20px' }}
              loading={updating}
              disabled={invalid || updating}
            >
              {formatMessage(messages.submitButton)}
            </SubmitButton>
          </ModalFooter>
        </form>
      </Modal>
    );
  }
}

function mapStateToProps(state, props) {
  return {
    fetching: selectIsFetching(state),
    updating: selectIsUpdating(state),
    errorMessage: selectError(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    sendInvitationStart: () => dispatch({ type: actionTypes.SEND_INVITATION.START }),
    sendInvitationSuccess: () => dispatch({ type: actionTypes.SEND_INVITATION.SUCCESS }),
    sendInvitationError: error =>
      dispatch({
        type: actionTypes.SEND_INVITATION.FAILURE,
        payload: { error },
      }),
    addMessage: bindActionCreators(addMessage, dispatch),
    hideModal: bindActionCreators(hideModal, dispatch),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
const withReducer = injectReducer({
  key: 'EmsChallengeFriend',
  reducer: EmsChallengeFriendReducer,
});

export default compose(withReducer, withConnect)(
  reduxModal({
    name: MODAL_NAME,
  })(
    reduxForm({
      form: formName,
      validate,
    })(injectIntl(withApollo(EmsChallengeFriend)))
  )
);
